<div class="container-fluid">
  <div class="row">
    <div *ngIf="!isLoginPage()" class="main-container">
      <!-- Sidebar -->
      <nav [class.collapsed]="sidebarCollapsed" class="sidebar">
        <button (click)="toggleSidebar()" class="collapse-btn">
          <i
            class="fa"
            [ngClass]="
              sidebarCollapsed ? 'fa fa-chevron-circle-right' : 'fa fa-chevron-circle-left'
            "
          ></i>
        </button>
        <img
          *ngIf="!sidebarCollapsed"
          src="assets/icons/talking-buddy.svg"
          alt="talking-buddy"
          class="sidebar-logo"
        />
        <img
          *ngIf="sidebarCollapsed"
          src="assets/icons/icon.svg"
          alt="logo"
          class="sidebar-icon-logo"
        />
        <ul class="nav flex-column">
          <li class="nav-item">
            <a class="nav-link" href="#/dashboard" [ngClass]="{ active: isActive('/dashboard') }">
              <i class="fa fa-th-large" aria-hidden="true"></i>
              <span *ngIf="!sidebarCollapsed">{{ 'MENU_ITEMS.DASHBOARD' | translate }}</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#/user" [ngClass]="{ active: isActive('/user') }">
              <i class="fa fa-users" aria-hidden="true"></i>
              <span *ngIf="!sidebarCollapsed">{{ 'MENU_ITEMS.USERS' | translate }}</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#/call" [ngClass]="{ active: isActive('/call') }">
              <i class="fa fa-phone" aria-hidden="true"></i>
              <span *ngIf="!sidebarCollapsed">{{ 'MENU_ITEMS.CALLS' | translate }}</span>
            </a>
          </li>
          <li class="nav-item" [ngClass]="{ 'li-support-item': !sidebarCollapsed }">
            <a class="nav-link" href="#/dispute" [ngClass]="{ active: isActive('/dispute') }">
              <i class="fa fa-comment" aria-hidden="true"></i>
              <span *ngIf="!sidebarCollapsed">{{ 'MENU_ITEMS.DISPUTES' | translate }}</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#/payment" [ngClass]="{ active: isActive('/payment') }">
              <i class="fa fa-credit-card" aria-hidden="true"></i>
              <span *ngIf="!sidebarCollapsed">{{ 'MENU_ITEMS.PAYMENTS' | translate }}</span>
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              href="#/notification"
              [ngClass]="{ active: isActive('/notification') }"
            >
              <i class="fa fa-bell" aria-hidden="true"></i>
              <span *ngIf="!sidebarCollapsed">{{ 'MENU_ITEMS.NOTIFICATIONS' | translate }}</span>
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              href="#/signIn"
              [ngClass]="{ active: isActive('#/signIn') }"
              (click)="logout()"
            >
              <i class="fa fa-sign-out" aria-hidden="true"></i>
              <span *ngIf="!sidebarCollapsed">{{ 'MENU_ITEMS.LOGOUT' | translate }}</span>
            </a>
          </li>
        </ul>
        <footer class="sidebar-footer">
          <span *ngIf="!sidebarCollapsed">{{ portalVersion }}</span>
        </footer>
      </nav>

      <!-- Main Content Area -->
      <div class="content-area">
        <!-- Header -->
        <header class="header d-flex align-items-center justify-content-between p-4 ml-2">
          <h3 *ngIf="isActive('/dashboard')">
            {{ 'DASHBOARD_PAGE.HEY' | translate }} <span class="text-primary">{{ userName }}</span
            >, {{ 'DASHBOARD_PAGE.WELCOME_BACK' | translate }}
          </h3>
          <h3 *ngIf="isActive('/user')">{{ 'MENU_ITEMS.USERS' | translate }}</h3>
          <h3 *ngIf="isActive('/call')">{{ 'MENU_ITEMS.CALLS' | translate }}</h3>
          <h3 *ngIf="isActive('/dispute')">{{ 'MENU_ITEMS.DISPUTES' | translate }}</h3>
          <h3 *ngIf="isActive('/payment')">{{ 'MENU_ITEMS.PAYMENTS' | translate }}</h3>
          <h3 *ngIf="isActive('/notification')">{{ 'MENU_ITEMS.NOTIFICATIONS' | translate }}</h3>
          <img src="assets/icons/icon-profile.png" alt="Avatar" class="avatar" />
        </header>

        <!-- Main Content -->
        <div class="content">
          <router-outlet></router-outlet>
          <!-- Dynamic content goes here -->
        </div>
      </div>
    </div>
  </div>
</div>
